module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/adminlogin/adminlogin.component.scss
// module id = ./src/app/adminlogin/adminlogin.component.scss
// module chunks = main